import { render, staticRenderFns } from "./CardAuthorTable.vue?vue&type=template&id=92a2ac58&"
import script from "./CardAuthorTable.vue?vue&type=script&lang=js&"
export * from "./CardAuthorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports